var dom = {},

	state = {},

	customAnalytics = require("custom-analytics"),

	$ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null),

	domCache = require("dom-cache"),

	setupDom = function() {

		dom.document = $(document);
		dom.body = $("body");
		dom.htmlBody = $("html,body");
		dom.productCodes = $("[name='productCodes']");
		dom.checkoutBtn = $(".detail-check-out-btn,.js-check-out");
		dom.suggestedProductsHdr = $(".suggested-products-hdr");
		dom.suggestedProductsAnchor = $("[name='suggested-products']");
		dom.suggestedProductsList = $(".suggested-product-list");
		dom.suggestedProductListItems = dom.suggestedProductsList.find("li");
		dom.purchaseBtn = $(".checkout-form .btn.submit");
		dom.previewBtn = $(".detail-preview-btn");
		dom.mainProductImg = $(".detail-main-img-wrapper img");
		dom.selectBtns = $(".select-suggested-product-btn");
		dom.selectPlanBtn = $(".block-pricing__select-btn");
		dom.productNavContainer = $(".product-nav-container");
		dom.checkoutContainer = $(".checkout-container");
		dom.planGetStartedBtn = $(".block-pricing__get-started-btn--scroller");
		dom.topFeatureLink = $(".block-pricing__top-feature-link");

	},

	setupInitialState = function() {

		state.promocodeExpanded = false;
		state.giftcardExpanded = false;
		state.productCodes = [];

	},

	addEventHandlers = function() {

		dom.previewBtn.add("[data-preview-url]").on("click", function(e){

			window.open($(this).attr("data-preview-url"));

			e.preventDefault();

		});


		dom.topFeatureLink.on('click', onTopFeatureLinkClicked);


		dom.document.on("ready", function() {

			var initialProdcode = dom.body.attr("data-product-code");

			if(initialProdcode){
				addProductCode(initialProdcode);
				updateOrderDetails();
			}

		});


		dom.selectPlanBtn.on('click', onSelectPlanBtnClicked);
		dom.planGetStartedBtn.on('click', onPlanGetStartedBtnClicked);


		// click handler for adding/selecting products to add to the cart
		dom.document.on("click", ".add-suggested-product-btn,.select-suggested-product-btn:not(.disabled)", function(e){

			var $btn = $(this),
				$li = $btn.closest("li"),
				isAddingProductToCart = !$li.hasClass("in-cart"),
				isOnlyOneProductSelectable = $btn.hasClass("select-suggested-product-btn"), // the occurs when the user can only add ONE of the suggested products (i.e., because they may conflict with each other)
				performScroll;

			toggleSuggestedProductContainerState($li, isAddingProductToCart, isOnlyOneProductSelectable);

			toggleSuggestedProductBtnState($btn, isAddingProductToCart, isOnlyOneProductSelectable);

			updateProductsInCart($btn.attr("data-product-code"), isAddingProductToCart);

			if(isOnlyOneProductSelectable){

				updateStateOfSelectedBtns($btn, isAddingProductToCart);

			}

			// we need to update the order details, but first, let's determine if we need to
			// scroll down to the checkout form upon adding
			performScroll = isOnlyOneProductSelectable ? true : haveAllSuggestedProductsBeenAdded();

			updateOrderDetails(performScroll);

			e.preventDefault();

		});

		dom.document.on("click", ".select-suggested-product-btn.disabled", function(e){

			e.preventDefault();

		});

		dom.checkoutBtn.on("click", function(e){

			var height = dom.productNavContainer.height();
			var offsetPadding = 20;
			var offset = height > 0 ? -(height + offsetPadding) : 0;

			e.preventDefault();

			e.stopPropagation();

			if(isSeoPurchasePage()) {

				scrollToAnchor("suggested-products", offset - 40);

			} else {

				scrollToAnchor("checkout-form", offset);

			}

		});

		dom.document.on("click", ".apply-promo-code-btn,.apply-gift-card-btn", function(e){

			if(hasEnteredValue($(this))){

				updateOrderDetails();

			}

			e.preventDefault();

		});

		dom.document.on("keypress", "[name='promocode'],[name='giftcard']", function(e){

			if(e.which === 13) {

				updateOrderDetails();

				e.preventDefault();

			}

		});

		// zibster plan selection
		dom.document.on("click", ".plan-select-btn", function(e){

			var $btn = $(this),
				$container = $btn.closest(".plan"),
				$allPlanContainers = $(".plan"),
				$label = $btn.find(".label"),
				isSelected = $container.is(".selected");

			clearProductCodes();

			$allPlanContainers.removeClass("selected").find(".label").text("select");


			if(isSelected){

				$label.text("select");

				updateOrderDetails();

			}

			else { // select this plan

				addProductCode($btn.attr("data-product-code"));

				$label.text("selected");

				$container.addClass("selected");

				updateOrderDetails(true);

			}


			e.preventDefault();

		});

		dom.document.on("click", ".remove-promo-code-btn,.promo-code-container .icon-remove", function(e){

			clearPromocode();

			state.promocodeExpanded = false;

			updateOrderDetails();

			e.preventDefault();

		});

		dom.document.on("click", ".remove-gift-card-btn,.gift-card-container .icon-remove", function(e){

			clearGiftcard();

			state.giftcardExpanded = false;

			updateOrderDetails();

			e.preventDefault();

		});

		dom.document.on("click", ".promo-code-link", function(e){

			$(this).hide();

			// must grab fresh as this is loaded via ajax
			$(".promo-code-input-container").show().find("input").focus();

			state.promocodeExpanded = true;

			e.preventDefault();

		});

		dom.document.on("click", ".gift-card-link", function(e){

			$(this).hide();

			// must grab fresh as this is loaded via ajax
			$(".gift-card-input-container").show().find("input").focus();

			state.giftcardExpanded = true;

			e.preventDefault();

		});

		dom.document.on("click", ".checkout-recurring-radio", function() {

			var $radio = $(this);
			var $container = $radio.closest(".checkout-recurring-container");
			var $recurring = $("input[name='recurring']");

			$container.find(".checkout-recurring-radio").removeClass("checked");

			$radio.addClass("checked");

			$recurring.val("monthly");

			if($radio.is(".checkout-recurring-annual")){

				$recurring.val("annual");

			}

			updateOrderDetails();

		});

	},

	onTopFeatureLinkClicked = function(e) {

		e.preventDefault();

		scrollToAnchor("shared-features", -90);

	},

	updateStateOfSelectedBtns = function($btn, isAddingProductToCart){

		if(isAddingProductToCart){

			console.log("disable the other buttons");

			// if we are selecting a product, disable other options
			dom.selectBtns.not($btn).addClass("disabled");

		}

		else {

			console.log("enable the buttons");

			// if we are deselecting the selected product, enable all products selection options
			dom.selectBtns.removeClass("disabled selected");

		}

	},

	haveAllSuggestedProductsBeenAdded = function() {

		var numSuggestedProds = dom.suggestedProductListItems.length,
			numSuggestedProdsAddedToCart = dom.suggestedProductListItems.filter(".in-cart").length,
			result = false;

		if(numSuggestedProds === numSuggestedProdsAddedToCart){

			result = true;

		}

		return result;

	},

	scrollToAnchor = function(anchor, verticalOffset){

		var targetMap = {
			'checkout-form': $("[name='checkout-form']"),
			'checkout-container': $('.checkout-container'),
			'suggested-products': dom.suggestedProductsAnchor,
			'plan-selection-hdr': $("[name='plan-selection-hdr']"),
			'shared-features': $("[name='shared-features']")
		};

		verticalOffset = typeof verticalOffset !== 'undefined' ? verticalOffset : 0;

		dom.htmlBody.stop().animate({

			"scrollTop": targetMap[anchor].offset().top + verticalOffset

		}, 600, "swing", function() {

			window.location.hash = anchor;

		});

	},

	onPlanGetStartedBtnClicked = function(e) {

		e.preventDefault();

		scrollToAnchor("plan-selection-hdr");

	},

	onSelectPlanBtnClicked = function(e) {

		var $btn = $(this);
		var productCodes = $btn.attr('data-product-codes').split();
		var i;

		e.preventDefault();

		clearProductCodes();

		for (i = 0; i < productCodes.length; i++) {

			addProductCode(productCodes[i]);

		}

		var isSelected = $.trim($btn.text()) === 'MY PLAN';

		if (isSelected) {
			return;
		} else {
			$('.block-pricing__select-btn').css('cursor', 'pointer').text('SELECT');
			$btn.text('MY PLAN');
			$btn.css('cursor', 'default');

			var $selectedPlan = dom.document.find('.sign-up__selected-plan');
			var $selectedPlanContainer = dom.document.find('.sign-up__selected-plan-container');
			var $noPlanSelectedContainer = dom.document.find('.sign-up__no-plan-selected-container');
			var planName = $btn.attr('data-plan-name');

			$selectedPlanContainer.show();
			$noPlanSelectedContainer.hide();
			$selectedPlan.text(planName);

			$selectedPlan.removeClass('sign-up__selected-plan--custom sign-up__selected-plan--managed');

			if (planName === 'custom site') {
				$selectedPlan.addClass('sign-up__selected-plan--custom');
			} else if (planName === 'managed site') {
				$selectedPlan.addClass('sign-up__selected-plan--managed');
			}

		}

		updateOrderDetails();


		if (!dom.checkoutContainer.find('.checkout-form').is(':visible')) {

			dom.checkoutContainer.show();

			scrollToAnchor('checkout-container');

		} else {

			scrollToAnchor('checkout-form');
			
		}


	},

	hasEnteredValue = function($el){ // has the user entered a promo code or gift card

		var $container = $el.closest("div"),
			isPromoCode = $el.is(".apply-promo-code-btn"),
			$input = $container.find("input"),
			$allMsgs = $(".checkout-validation-msg"),
			$thisMsg = $container.find(".checkout-validation-msg"),
			msgStr = isPromoCode ? "please enter a valid promocode" : "please enter a valid giftcard";

		$allMsgs.text("");

		if($input.val() === ""){

			$thisMsg.text(msgStr);

			return false;

		}

		return true;

	},

	updateAnalyticsAttr = function(switchToRemove, $btn){

		var str = $btn.attr("data-analytics");

		if (str && str.length) {

			if(switchToRemove){

				str = str.replace(/added to/g, "removed from");
				str = str.replace(/add/g, "remove");

			}

			else {

				str = str.replace(/removed from/g, "added to");
				str = str.replace(/remove/g, "add");

			}

			$btn.attr("data-analytics", str);

		}

	},

	toggleSuggestedProductBtnState = function($btn, isAdd, isSelect){

		var btnHtml = $btn.html();

		if(isAdd){

			if(isSelect){

				$btn.html(btnHtml.replace("select", "remove"));

			}

			else {

				$btn.html(btnHtml.replace("add", "remove"));

			}

		}

		else {

			if(isSelect){

				$btn.html(btnHtml.replace("remove", "select"));

			}

			else {

				$btn.html(btnHtml.replace("remove", "add"));

			}

		}

		customAnalytics.registerTransmissionCallback(function() {
			updateAnalyticsAttr(isAdd, $btn)
		});

	},

	toggleSuggestedProductContainerState = function($el, isAdd){

		if(isAdd){

			$el.addClass("in-cart");

		}

		else {

			$el.removeClass("in-cart");

		}

	},

	isSeoPurchasePage = function() {

		return dom.body.is(".page-seo");

	},

	updateProductsInCart = function(productCode, isAdd){

		var numProductsInCart,
			$formWrapper = $(".footer-form-wrapper");

		if(isAdd){

			addProductCode(productCode);

		}

		else {

			removeProductCode(productCode);

			numProductsInCart = getNumProductsInCart();

			if(isSeoPurchasePage() && numProductsInCart < 2) {

				$formWrapper.hide();

			}

		}

	},

	getNumProductsInCart = function() {

		var codes = getProductCodes().split(",");

		return codes.length;

	},

	clearProductCodes = function() {

		state.productCodes = [];

	},

	addProductCode = function(newCode){

		state.productCodes.push(newCode);

		console.log(state.productCodes);

	},

	removeProductCode = function(newCode){

		var idx = state.productCodes.indexOf(newCode)
		
		if(idx > -1){
			state.productCodes.splice(idx, 1);
		}

		console.log(state.productCodes);

	},

	clearGiftcard = function() {

		$("[name='giftcard']").val("");

	},

	clearPromocode = function() {

		$("[name='promocode']").val("");

	},

	getProductCodes = function() {

		return state.productCodes.join(",");

	},

	updateOrderDetails = function(performScroll){

		var productCodes = getProductCodes(),
			promocode = $("[name='promocode']").val() || "",
			giftcard = $("[name='giftcard']").val() || "",
			prodName = $("[name='prodName']").val() || "",
			recurring = $("[name='recurring']").val() || "annual",
			email = $("[name='email']").val() || "",
			password = $("[name='password']").val() || "",
			cardName = $("[name='cardName']").val() || "",
			cardNumber = $("[name='cardNumber']").val() || "",
			cardCvv = $("[name='cardCvv']").val() || "",
			sampleId = $("[name='sampleId']").val() || $("[data-sample-id]").attr("data-sample-id") || "",
			cardMonth = $("[name='cardMonth']").val() || 01,
			today = new Date(),
			cardYear = $("[name='cardYear']").val() || today.getUTCFullYear().toString().substr(2,2),
			$checkoutContainer = $("#checkoutContainer"),
			$formWrapper;


		if(productCodes.length){

			$.ajax({

				type: "POST",
				url: "/corporate/includes/form_checkout.cfm",
				data: {
					product: productCodes,
					promocode: promocode,
					giftcard: giftcard,
					promocodeExpanded: state.promocodeExpanded,
					giftcardExpanded: state.giftcardExpanded,
					recurring: recurring,
					prodName: prodName,
					email: email,
					password: password,
					cardName: cardName,
					cardNumber: cardNumber,
					cardCvv: cardCvv,
					cardMonth: cardMonth,
					cardYear: cardYear,
					sampleId: sampleId
				},
				success: function() {

					$checkoutContainer.html(arguments[0]);

					$formWrapper = $(".footer-form-wrapper");

					if(!isSeoPurchasePage() || getNumProductsInCart() >= 2) {

						$formWrapper.css({
							display: "block"
						});

						if(performScroll){
							scrollToAnchor("checkout-form");
						}

					}

					domCache.triggerCustomEvent({
						type: 'checkout_form_loaded'
					});

				}

			});

		}

		else {

			$checkoutContainer.html("");

		}		

	},

	init = function() {

		setupDom();

		setupInitialState();

		addEventHandlers();

	};

init();